import { Formik } from 'formik';
import { useTranslation } from 'react-i18next';
import type { CatalogCategoryKindType } from '@econtractor/types';
import { useToast } from 'context/ToastContext';
import { CATALOG_DIR_I18N_NS, catalogDirApi } from '../model/catalogDirApi';
import AddDirForm from './AddDirForm';

interface AddDirFormikProps {
    kind: CatalogCategoryKindType;
    onCreated: () => Promise<void>;
}

const AddDirFormik = ({ kind, onCreated }: AddDirFormikProps) => {
    const { t } = useTranslation([CATALOG_DIR_I18N_NS[kind], 'common']);
    const { showToast } = useToast();

    return (
        <Formik
            initialValues={{ name: '' }}
            onSubmit={async (values, { resetForm, setFieldError }) => {
                const resCreate = await catalogDirApi[kind].create(values.name);
                if (resCreate?.stat) {
                    await onCreated();
                    resetForm();
                    showToast(t('dirs.messCreated'), 'success');
                    return;
                }

                if (resCreate?.errCode === 'DUPLICATE_NAME') {
                    setFieldError('name', t('dirs.messDuplicate'));
                    return;
                }
                if (resCreate?.errCode === 'EMPTY_NAME') {
                    setFieldError('name', t('dirs.messEmpty'));
                    return;
                }
                if (resCreate?.errCode === 'NAME_TOO_LONG') {
                    setFieldError('name', t('dirs.messTooLong'));
                    return;
                }

                showToast(t('common:messError'), 'danger');
            }}
        >
            {({ handleSubmit, isSubmitting, errors, touched }) => (
                <AddDirForm
                    kind={kind}
                    handleSubmit={handleSubmit}
                    isSubmitting={isSubmitting}
                    nameError={touched.name && errors.name ? errors.name : ''}
                />
            )}
        </Formik>
    );
};

export default AddDirFormik;
